// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "embed{position:absolute;left:0;bottom:0;height:100%;z-index:99999}.head{display:block!important}", ""]);
// Exports
module.exports = exports;
